import { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CardHeader,
  Container,
  Divider,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Grid
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const EditGotra = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [gotra, setGotra] = useState('');
  const [kuldevi, setkuldevi] = useState('');
  const [parentgotra, setparentgotra] = useState('');
  const [gotraErr, setGotraErr] = useState(false);
  const [kuldeviErr, setkuldeviErr] = useState(false);
  const [parentgotraErr, setparentgotraErr] = useState(false);
  const [allGotras, setAllGotras] = useState([]);

  const getData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/gotra/${id}`
      );
      const data = response.data.data; // Access the data object
      setGotra(data.gotra);
      setkuldevi(data.kuldevi); // Set kuldevi from response
      setparentgotra(data.parentgotra); // Set parentgotra from response
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getallGotra = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/gotra/getAll`
      );
      const data = response?.data?.data;
      setAllGotras(data);
    } catch (err) {
      toast.error(err?.response?.data?.message, { position: 'bottom-right' });
    }
  };
  useEffect(() => {
    getallGotra();
  }, []);

  const handleEdit = async (e) => {
    e.preventDefault();

    // Validate fields
    let hasError = false;
    if (gotra === '') {
      setGotraErr(true);
      hasError = true;
    }
    // if (kuldevi === "") {
    //     setkuldeviErr(true);
    //     hasError = true;
    // }
    // if (parentgotra === "") {
    //     setparentgotraErr(true);
    //     hasError = true;
    // }

    if (hasError) return; // Exit if there are validation errors

    try {
      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/gotra/edit/${id}`,
        {
          gotra: gotra,
          kuldevi: kuldevi,
          parentgotra: parentgotra
        }
      );
      toast.success('Gotra updated successfully!', {
        position: 'bottom-right'
      });
      navigate('/gotra');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Error updating gotra', {
        position: 'bottom-right'
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Edit Gotra</title>
      </Helmet>

      <Container maxWidth="lg" sx={{ mt: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={2}
        >
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Edit Gotra"
                titleTypographyProps={{
                  style: {
                    margin: 10,
                    width: '100%',
                    color: '#000',
                    fontWeight: 700,
                    fontSize: '30px',
                    marginBottom: '30px'
                  }
                }}
              />
           
              <CardContent>
                <form onSubmit={handleEdit}>
                  <div className="box-1-top-22">
                    <div style={{ margin: 9, width: '30%' }}>
                      <FormControl fullWidth>
                        <TextField
                          id="gotra"
                          label="Gotra"
                          name="gotra"
                          type="text"
                          value={gotra}
                          onChange={(e) => {
                            setGotra(e.target.value);
                            setGotraErr(false);
                          }}
                        />
                        {gotraErr && (
                          <span
                            style={{
                              color: 'red',
                              display: 'flex',
                              paddingTop: '10px'
                            }}
                          >
                            Gotra is required.
                          </span>
                        )}
                      </FormControl>
                    </div>
                    <div style={{ margin: 9, width: '30%' }}>
                      <FormControl fullWidth>
                        <TextField
                          id="kuldevi"
                          label="kuldevi"
                          name="kuldevi"
                          type="text"
                          value={kuldevi}
                          onChange={(e) => {
                            setkuldevi(e.target.value);
                            setkuldeviErr(false);
                          }}
                        />
                      </FormControl>
                    </div>
                    <div style={{ margin: 9, width: '30%' }}>
                      <FormControl fullWidth>
                        <InputLabel id="parentgotra-label">
                          Parent Gotra
                        </InputLabel>
                        <Select
                          labelId="parentgotra-label"
                          id="parentgotra"
                          name="parentgotra"
                          value={parentgotra}
                          onChange={(e) => {
                            setparentgotra(e.target.value);
                            setparentgotraErr(false);
                          }}
                          label="Parent Gotra" // This associates the label with the Select
                        >
                          {allGotras.map((option) => (
                            <MenuItem key={option._id} value={option.gotra}>
                              {option.gotra}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      style={{ marginRight: '10px', margin:'10px' }}
                    >
                      Submit
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => navigate('/gotra')}
                    >
                      Back to Gotra
                    </Button>
                  </div>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default EditGotra;
